import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs md:text-[13px] text-foreground-500 flex-wrap">
      <Link to="/" className="hover:text-primary-600 transition-colors flex items-center gap-1">
        <i className="ri-home-4-line" />
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-400" />
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 max-w-[240px] truncate">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}